import { Box, Button, Grid2, Typography } from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useState } from "react";
import { ReactComponent as TimerIcon } from "Assets/Icons/Classroom/TimerIcon.svg";
import { ReactComponent as AttemptedIcon } from "Assets/Icons/Classroom/AttemptedIcon.svg";
import { ReactComponent as ProfileIcon } from "Assets/Icons/Home/ProfileIcon.svg";
import ContestInstructions from "./ContestInstructions";
import PrimarySlider from "Components/Common/PrimarySlider";
import { SwiperSlide } from "swiper/react";
import ContestAllQues from "./Question/ContestAllQues";
import ContestQuestionDetail from "./Question/ContestQuestionDetail";
import ReportIssue from "./ReportIssue";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
});
const ContestPage = () => {
  const [selectedQue, setSelectedQue] = useState("All");

  const questionsList = [
    "All",
    "Question 1",
    "Question 2",
    "Question 3",
    "Question 4",
    "Question 5",
    "Question 6",
    "Question 7",
    "Question 8",
  ];

  return (
    <Grid2 sx={styles}>
      <Box
        sx={(theme) => ({
          border: `1px solid ${theme.palette.border.blue}`,
          borderRadius: "8px",
          padding: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        })}
      >
        <Box display={"flex"} gap="16px">
          <Box
            sx={(them) => ({
              borderRadius: "8px",
              background: "#FFF7E8",
              padding: "8px",
            })}
          >
            <Typography
              display={"flex"}
              alignItems={"center"}
              gap="6px"
              variant="subtitle"
              fontWeight={500}
            >
              <PrimaryIcon width="16px" icon={TimerIcon} />
              00 Hr : 52 min : 19 sec
            </Typography>
          </Box>
          <Box
            sx={(them) => ({
              borderRadius: "8px",
              background: "#F1EDFF",
              padding: "8px",
            })}
          >
            <Typography
              display={"flex"}
              alignItems={"center"}
              gap="6px"
              variant="subtitle"
              fontWeight={500}
            >
              <PrimaryIcon icon={AttemptedIcon} width="16px" />
              Attempted
              <Box
                sx={(theme) => ({
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  "& .empty": {
                    background: theme.palette.white.main,
                    width: "100px",
                    display: "flex",
                    height: "5px",
                    borderRadius: "16px",
                  },
                  "& .filled": {
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: theme.palette.success.main,
                    width: "20px",
                    display: "flex",
                    height: "3px",
                    borderRadius: "16px",
                  },
                })}
              >
                <span className="empty" />
                <span className="filled" />
              </Box>
              <Typography variant="body2" color="secondary.light">
                02/06
              </Typography>
            </Typography>
          </Box>
          <Button
            variant="contained"
            sx={(theme) => ({
              background: "#F5F5F5",
              color: theme.palette.secondary.light,
            })}
          >
            End Test
          </Button>
        </Box>
        <Box display={"flex"} gap="16px" alignItems={"center"}>
          <ReportIssue />
          <Box
            sx={(theme) => ({
              border: `1px solid ${theme.palette.border.blue}`,
              borderRadius: "8px",
              padding: "4px 6px",
            })}
          >
            <PrimaryIcon height="22px" width="22px" icon={ProfileIcon} />
          </Box>
        </Box>
      </Box>
      <Typography fontWeight={600} fontSize={"28px"}>
        DAV - Python Libraries
      </Typography>
      <ContestInstructions />
      <Box>
        <Typography variant="title" fontWeight={500}>
          All Sections and Questions
        </Typography>
        <Typography color="secondary.light">
          Default Section (6 Question)
        </Typography>
      </Box>
      <Box width={"100%"}>
        <PrimarySlider
          slidesPerView={{
            1200: { slidesPerView: 7 },
            900: { slidesPerView: 5 },
            600: { slidesPerView: 3 },
            0: { slidesPerView: 2 },
          }}
          spacing={"15px"}
        >
          {questionsList?.map((item, i) => {
            return (
              <SwiperSlide>
                <Box
                  onClick={() => setSelectedQue(item)}
                  sx={(theme) => ({
                    border: `1px solid ${theme.palette.border.blue}`,
                    borderRadius: "8px",
                    padding: "10px",
                    textAlign: "center",
                    cursor: "pointer",
                    fontWeight: 500,
                    ...(selectedQue == item && {
                      color: theme.palette.white.main,
                      background: theme.palette.primary.main,
                    }),
                  })}
                >
                  {item}
                </Box>
              </SwiperSlide>
            );
          })}
        </PrimarySlider>
      </Box>
      {selectedQue == "All" ? <ContestAllQues /> : <ContestQuestionDetail />}
    </Grid2>
  );
};

export default ContestPage;
